export default __webpack_public_path__ + "static/media/ico-tree.675b7daf.svg";